import { CanActivateFn, Routes } from '@angular/router';
import { environment } from '@env/environment';
import { IPSLandingComponent } from '@ips/common-angular';
import { authorizationGuard } from './guards/auth.guard';
import { HomeComponent } from './home/home.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { OrderDetailsComponent } from './orders/order-details/order-details.component';
import { OrderSuccessComponent } from './orders/order-success/order-success.component';
import { PlaceOrderComponent } from './orders/place-order/place-order.component';

/**
 * npm run start:noApi
 */
const authBypass: CanActivateFn = () => {
    console.warn('Running in noApi mode');
    return true;
}

export const routes: Routes = [
    { 
        path: '', 
        component: environment.noAuth ? HomeComponent : IPSLandingComponent,
        data: {
            redirectUrl: 'home',
            showTokenReview: false,
            // FIXME: use prod one when available
            headerSourceImageUrl: "https://ips-login-np.exlservice.com/adfs/portal/illustration/illustration.jpg?id=3F030362C8A2DA952FAFD2B6B7B058156910DB407D8DE4735A294342414E5E35&rp=14fc06f5-18e3-ef11-be71-005056a16560",
            brandingBackgroundColor: "#fff",
            showCarrierSelection: true,
            showBrandingPortal: true
        }
    },
    {
        path: 'home', 
        component: HomeComponent,
        canActivate: [environment.noAuth ? authBypass : authorizationGuard],
        children: [ 
            { path: '', component: LandingPageComponent },
            // { path: 'order-info', component: OrderInfoComponent }
            { path: 'place-order', component: PlaceOrderComponent },
            { path: 'order-success', component: OrderSuccessComponent },
            { path: 'order-details/:id', component: OrderDetailsComponent }
        ]
    }
];
